export enum MapOnboardingSteps {
  simpleBoostOnboarding,
  superBoostOnboarding,
}
